var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 10.0233C18.3334 5.42327 14.6 1.68994 10 1.68994C5.40002 1.68994 1.66669 5.42327 1.66669 10.0233C1.66669 14.0566 4.53335 17.4149 8.33335 18.1899V12.5233H6.66669V10.0233H8.33335V7.93994C8.33335 6.33161 9.64169 5.02327 11.25 5.02327H13.3334V7.52327H11.6667C11.2084 7.52327 10.8334 7.89827 10.8334 8.35661V10.0233H13.3334V12.5233H10.8334V18.3149C15.0417 17.8983 18.3334 14.3483 18.3334 10.0233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarFacebook);
export default __webpack_public_path__ + "static/media/SidebarFacebook.c7b834c073153a8e631cf04007188ecc.svg";
export { ForwardRef as ReactComponent };